import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-multi-report-actions',
  templateUrl: './multi-report-actions.component.html',
  styleUrls: ['./multi-report-actions.component.scss']
})
export class MultiReportActionsComponent implements OnInit {
  @Input() data;
  Form: FormGroup;
  trimester: any[] = [];
  showDate = false;
  showOrder = false;
  yearReclaim = 0;

  /* Modal cases (Order always required)
    1: security, benefits , entity. // Relation List
    2: request, operation, progresive, company, client, days, dateRegister, trimesterId // Reclamo
    3: product, received, delete, percent, dateRegister, trimesterId// Loss
   */
  constructor(private fb: FormBuilder,
              public activeModal: NgbActiveModal) {
  }

  min: Date;
  max: Date;

  ngOnInit(): void {
    this.yearReclaim = this.data['yearReclaim'];

    this.Form = this.fb.group({
      benefits: [this.data['benefits'] || null],
      client: [this.data['client'] === null ? null :  this.data['client'] === 0 ? 0 : this.data['client'] || null],
      company: [this.data['company'] === null ? null :  this.data['company'] === 0 ? 0 : this.data['company'] || null],
      days: [this.data['days'] === null ? null :  this.data['days'] === 0 ? 0 : this.data['days'] || null],
      delete: [this.data['delete'] === null ? null :  this.data['delete'] === 0 ? 0 : this.data['delete'] || null],
      dateRegister: [this.data['dateRegister'] || null],
      entity: [this.data['entity'] || null],
      security: [this.data['security'] || null],
      request: [this.data['request'] || null],
      operation: [this.data['operation'] || null],
      total: [this.data['total'] === null ? null :  this.data['total'] === 0 ? 0 : this.data['total'] || null],
      progresive: [this.data['progresive'] === null ? null :  this.data['progresive'] === 0 ? 0 : this.data['progresive'] || null],
      product: [this.data['product'] || null],
      percent: [this.data['percent'] === null ? null :  this.data['percent'] === 0 ? 0 : this.data['percent'] || null],
      received: [this.data['received'] === null ? null :  this.data['received'] === 0 ? 0 : this.data['received'] || null],
      trimesterId: [this.data['trimesterId'], [Validators.required]],
      orderId: [{value: this.data['orderId'] || 0, disabled: true}, [Validators.required]],
      subReason: [this.data['subReason'] || null],
    });

    if (this.data['trimester']) {
      this.Form.get('trimesterId').setValue(this.data['trimester'].id);
      this.min = this.data['trimester'].startDate;
      this.max = this.data['trimester'].endDate;
      this.Form.get('dateRegister').setValue(this.min);
    }

    switch (this.data['modal'].type) {
      case 1:
        this.Form.get('security').setValidators([Validators.required]);
        this.Form.get('benefits').setValidators([Validators.required]);
        this.Form.get('entity').setValidators([Validators.required]);
        this.Form.get('trimesterId').setValidators([]);
        break;
      case 2:
        if (this.yearReclaim >= 2024) 
          this.Form.get('product').setValidators([Validators.required]);
        else
          this.Form.get('operation').setValidators([Validators.required]);
        this.Form.get('request').setValidators([Validators.required]);
        this.Form.get('dateRegister').setValidators([Validators.required]);
        break;
      case 3:
        this.Form.get('product').setValidators([Validators.required]);
       /* this.Form.get('received').setValidators([Validators.required]);
        this.Form.get('delete').setValidators([Validators.required]);
        this.Form.get('percent').setValidators([Validators.required]);*/
        this.Form.get('dateRegister').setValidators([Validators.required]);
        break;
    }
  }

  send(): void {
    const emitted = {...this.Form.getRawValue()};
    for (const item in emitted) {
      if (emitted.hasOwnProperty(item) && emitted[item] === null) {
        delete emitted[item];
      }
    }
    this.activeModal.close(emitted);
  }
}
